export const STOREFRONT_NAME = 'Pixie World'
export const CHECKOUT_TOKEN = 'checkoutToken'
export const DEMO_MODE = process.env.NEXT_PUBLIC_DEMO_MODE === 'true'
export const HOMEPAGE_MENU = process.env.NEXT_PUBLIC_HOMEPAGE_MENU || ''
export const HOMEPAGE_BLOCK = 'homepage'
export const GEOLOCATION = process.env.NEXT_PUBLIC_GEOLOCATION === 'true'
export const REVALIDATION_FREQUENCY = process.env.NODE_ENV === 'production' ? 60 * 60 : 1

export const STOREFRONT_API_KEY = process.env.STOREFRONT_API_KEY || ''
export const API_URI = process.env.NEXT_PUBLIC_API_URI || ''
export const NEXT_PUBLIC_RECAPTCHA_SITE_KEY = '6LeNAAIrAAAAAJ-PdS7zdu-1DhYThPfq9_n1Tzd9'
export const PIXIEWORLD_API_URI = process.env.NEXT_PUBLIC_PIXIEWORLD_API_URI || ''

export const NEXT_GOOGLE_CLIENT_ID  = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || '618680036230-p6la4fqvkvj93e4t71cs1dca6jncuufu.apps.googleusercontent.com'

export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || 'G-SX8L9J0D0W'
export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID || ''
